<!--
 * @Author: your name
 * @Date: 2020-07-02 15:55:51
 * @LastEditTime : 2020-09-29 09:24:15
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\components\footer\footer.vue
--> 
<template>
  <div class="footer">
    Copyright  版权所有 北京尚壹本科技有限公司 
    <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">京ICP备2020041938号-1</a>
  </div>
</template>

<script>


export default {   
  name: 'footers'  
}
</script>

<style scoped >
.footer{
  width : 100%;
  background :#5c307d;
  position: fixed;
  bottom: 0;
  height: 43px;
  color : #ffffff;
  text-align: center;
  font-size: 14px;
  clear:both;
}
.footer a {
  margin-left: 20px;
  color: #fff;
  line-height: 43px;
}
</style>